import type { LoginResponse } from 'src/requests/user.js';
import { addListener } from '../common';

export const onLoginWithCoperaApp =
  addListener<LoginResponse>('/login/received');
